import React from "react";
import { withRouter } from "react-router-dom";
import { getDeviceProtectionItems, getItemsThatRequireShipping, getShippingProtectionItems } from "../Helpers/OderUtils";
import "../Styles/_LineItemsInformation.css";
import LineItem from "./_LineItem";

const adjustQuantities = (items, refundedItems, refunded) => {
    return items
        .map(item => {
            const refundedItem = refundedItems.find(refItem => refItem.id === item.id);
            if (refundedItem) {
                return { ...item, quantity: refunded ? refundedItem.quantity : item.quantity - refundedItem.quantity };
            }
            return refunded ? null : item;
        })
        .filter(item => item && item.quantity > 0);
};

const getTableHeaderLabel = (currentLanguage, cancelled, refunded) => {
    if (cancelled) return currentLanguage.ORDER_PAGE.ITEMS_SECTION.CANCELLED.TITLE;
    if (refunded) return currentLanguage.ORDER_PAGE.ITEMS_SECTION.REFUNDED.TITLE;
    return currentLanguage.ORDER_PAGE.ITEMS_SECTION.ORDERED_ITEMS.TITLE;
};

const LineItemsInformation = ({ order, currentLanguage, refundedItems, refunded, cancelled, ordered, egiftcardsOpen }) => {
    const normalItems = adjustQuantities(getItemsThatRequireShipping(order), refundedItems, refunded);
    const deviceProtectionItems = adjustQuantities(getDeviceProtectionItems(order), refundedItems, refunded);
    const shippingProtectionItems = adjustQuantities(getShippingProtectionItems(order), refundedItems, refunded);
    const egiftcardItems = adjustQuantities(order.egift_cards, refundedItems, refunded);

    const hasItems = normalItems.length > 0 || egiftcardItems.length > 0 || deviceProtectionItems.length > 0 || shippingProtectionItems.length > 0;

    if (!hasItems || (refunded && refundedItems.length === 0)) {
        return null;
    }

    const hasProtectionItems = deviceProtectionItems.length > 0 || shippingProtectionItems.length > 0;
    const itemsSection = currentLanguage.ORDER_PAGE.ITEMS_SECTION;

    return (
        <div className="line-items-container allow-focus" tabIndex="0">
            <div className="line-items-header">
                <div className="line-items-column-1">
                    <h2 style={{ margin: "0px" }}>{getTableHeaderLabel(currentLanguage, cancelled, refunded)}</h2>
                </div>
                <div className="line-items-column-2">{itemsSection.HEADER.QUANTITY}</div>
                <div className="line-items-column-3">{itemsSection.HEADER.TOTAL}</div>
            </div>
            <div className="flex layout vertical line-items-list">
                {normalItems.map((item, index) => (
                    <LineItem item={item} key={index} order={order} />
                ))}
                {hasProtectionItems && (
                    <React.Fragment>
                        <div className="line-items-divider">
                            <h3 className="line-items-list-sub-title">{itemsSection.PROTECTION.TITLE}</h3>
                        </div>
                        {deviceProtectionItems.map((item, index) => (
                            <LineItem item={item} key={index} order={order} />
                        ))}
                        {shippingProtectionItems.map((item, index) => (
                            <LineItem item={item} key={index} order={order} />
                        ))}
                    </React.Fragment>
                )}
                {egiftcardItems.length > 0 && (
                    <React.Fragment>
                        <div className="line-items-divider">
                            <h3 className="line-items-list-sub-title">{itemsSection.EGIFTCARDS.TITLE}</h3>
                            {ordered && (
                                <button
                                    type="button"
                                    className="allow-focus order-line-items-button"
                                    onClick={() => egiftcardsOpen("SEND_EGIFTCARDS_EMAIL", true)}
                                >
                                    {currentLanguage.ORDER_PAGE.MENU.SEND_EGIFTCARDS_EMAIL}
                                </button>
                            )}
                        </div>
                        {egiftcardItems.map((item, index) => (
                            <LineItem item={item} key={index} order={order} egiftcard />
                        ))}
                    </React.Fragment>
                )}
            </div>
        </div>
    );
};

export default withRouter(LineItemsInformation);
